import { titleCase } from "../../helpers/stringFormat";

export function documentTitle(props) {
    let title = "";
    if (props && props.title) {
        title = props.title;
    } else {
        const pathName = window.location.pathname;
        const parts = pathName.split("/")
        const partsFiltered = parts.filter(val => val.length > 0 && !val.startsWith("details") && !val.startsWith("000"))
        const titleParts = partsFiltered.map(val => titleCase(val.replaceAll("-", " ")))
        title = titleParts.join(" | ")
    }
    document.title = `Arpari | ${title}`
}